import React from "react";
import styled from 'styled-components';
import { colours } from "../Styles";
import { heights } from "../Styles";
import FlexSpaceCenter from './FlexSpaceCenter';
import MaxContent from './MaxContent';
import FlexCenterCenter from "./FlexCenterCenter";
import FlexStart from './FlexStart';
import FlexEnd from './FlexEnd';
import ContactItem from './ContactItem';
import { icons } from '../img/Icons';

function ContactBar() {
    const { phone, mail, instagram, facebook } = icons;
    const { transpBlack } = colours;
    const { contactBar } = heights;
    const ContactBar = styled.div`
    height: ${contactBar};
    width: 100%;
    background: ${transpBlack};
    position: fixed;
    top: 0;
    z-index: 5;
    @media only screen and (max-width: 600px) {
        visibility: hidden;
    }
    `;
  return (
    <ContactBar>
        <FlexCenterCenter>
            <MaxContent>
                <FlexSpaceCenter>
                    <FlexStart className="contact-item-wrapper">
                        <ContactItem icon={phone} content="647-973-3714" url="tel:647-973-3714"/>
                        <ContactItem icon={mail} content="precisiondetailgta@gmail.com" url="mailto:precisiondetailgta@gmail.com"/>
                    </FlexStart>
                    <FlexEnd>
                        <ContactItem icon={instagram} content="" url="https://www.instagram.com/precisiondetailgta/"/>
                        <ContactItem icon={facebook} content="" url="#"/>
                    </FlexEnd>
                </FlexSpaceCenter>
            </MaxContent>
        </FlexCenterCenter>
    </ContactBar>
  );
}

export default ContactBar;
